import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header wrap" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "account-settings-logout-link wallet-address"
}
const _hoisted_8 = { class: "modal-body no-padding" }
const _hoisted_9 = { class: "settings-list" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" })
], -1)
const _hoisted_11 = { class: "settings-list-item-caption" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock-open" })
], -1)
const _hoisted_13 = { class: "settings-list-item-caption" }
const _hoisted_14 = { class: "modal-body no-padding border-top" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "settings-list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" })
], -1)
const _hoisted_16 = { class: "settings-list-item-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-corner no-transition", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
    onKeydown: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Wallet")), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _hoisted_6, 8, _hoisted_4),
        (_ctx.address)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t("Address")) + ": " + _toDisplayString(_ctx.renderWalletAddress(_ctx.address)) + " (", 1),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyWalletAddress && _ctx.copyWalletAddress(...args)))
              }, _toDisplayString(_ctx.$t("Copy")), 1),
              _createTextVNode(") ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openPasswordChange && _ctx.openPasswordChange(...args)))
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("Change password")), 1)
          ], 32),
          _createElementVNode("div", {
            class: "settings-list-item",
            tabindex: "0",
            onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openExport && _ctx.openExport(...args)))
          }, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Export private key")), 1)
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "settings-list-item",
          tabindex: "0",
          onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickOnEnter && _ctx.clickOnEnter(...args))),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openWalletReplace && _ctx.openWalletReplace(...args)))
        }, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Replace wallet")), 1)
        ], 32)
      ])
    ])
  ], 42, _hoisted_1))
}